import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import moment from "moment";
import { formatAmount } from "../../../utility/CommonFunctions";
import CreateTransactionModal from "./CreateTransationModal";
import NoRecordIcon from "../../../components/Icons/NoRecordIcon";
import EditIcon from "../../../components/Icons/EditIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { useSelector } from "react-redux";
import CreateDebitNoteModal from "./CreateDebitNoteModal";
import { Spinner, Table } from "reactstrap";
import BgBlurLoader from "../../../components/Loaders/BgBlurLoader";
import MainHeading from "../../../components/comman/MainHeading";
import DownloadIcon from "../../../components/Icons/DownloadIcon";
import InvoicePreviewModal from "./UpdateBillingDetailsModal";
import UpdateBillingDetailsModal from "./UpdateBillingDetailsModal";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";

export default function InvoiceDetail() {
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [invoiceDetail, setInvoiceDetail] = useState({});
  const [months, setMonths] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const [editData, setEditData] = useState("");
  const [editDataForDebitNote, setEditDataForDebitNote] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  // console.log("editData====>", editData);
  const userDetails = useSelector((state) => state.root.userDetails);

  const [debitNoteModal, setDebitNoteModal] = useState(false);
  const toggleDebitNoteModal = () => {
    setDebitNoteModal(!debitNoteModal);
  };
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [docModal, setDocModal] = useState(false);
  const toggleDocModal = () => {
    setDocModal(!docModal);
  };
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const [updateBillingModal, setUpdateBillingModal] = useState(false);
  const toggleUpdateBillingModal = () => {
    setUpdateBillingModal(!updateBillingModal);
  };

  useEffect(() => {
    GetInvoiceDetail();
  }, []);

  const GetInvoiceDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_invoice_detail + `?invoiceId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setInvoiceDetail(response?.data);
        if (response?.data?.month) {
          try {
            let parsedMonths = typeof response?.data?.month === 'string'
              ? JSON.parse(response?.data?.month)
              : response?.data?.month;
            setMonths(Array.isArray(parsedMonths) ? parsedMonths : []);
          } catch (e) {
            setMonths([]);
          }
        }
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setDocModal(true);
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleDeleteModal();
  };

  const HandleUpdate = (data) => {
    if (data?.type === "debitNote") {
      setEditDataForDebitNote(data);
      toggleDebitNoteModal();
    } else {
      setEditData(data);
      toggleModal();
    }
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_transaction + `?transactionId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleDeleteModal();
        GetInvoiceDetail();
      } else {
        toast.error(response?.message);
        toggleDeleteModal();
      }
    });
  };

  const HandleDownloadInvoice = async () => {
    const API = `${apiUrl?.generate_invoice}?invoiceId=${id}`;

    try {
      setDownloadLoading(true);
      const response = await callApi(API, { method: "GET" });
      setDownloadLoading(false);
      if (response?.status === true && response?.data) {
        const fileUrl = response?.data;
        const fileName = `Invoice_${invoiceDetail?.invoiceNumber || "Invoice"
          }.pdf`;

        const fileResponse = await fetch(fileUrl);

        if (!fileResponse.ok) {
          throw new Error("Failed to fetch the file for download");
        }

        const blob = await fileResponse.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url); // clean up
      } else {
        toast.error(response?.message || "Failed to fetch file URL");
      }
    } catch (err) {
      console.error(err);
      toast.error("Download failed. Please try again.");
    }
  };



  // console.log("invoiceDetail=========>", invoiceDetail);

  return (
    <>
      {(isLoading || downloadLoading) && <BgBlurLoader />}
      <div className="content container-fluid">
        <MainHeading title="Invoice Detail"
          showBackButton={true}
          buttonText="Update Billing Details"
          buttonIcon={<EditIcon />}
          clickHandler={() => toggleUpdateBillingModal()}
        >
          <button
            className="btn btn-outline-primary px-5"
            onClick={HandleDownloadInvoice}
            disabled={invoiceDetail?.billedToName === null && invoiceDetail?.shippedToName == null}
          >
            {downloadLoading ? <Spinner size="sm" /> : <span className="me-2"><DownloadIcon /></span>}
            Download Invoice
          </button>
        </MainHeading>
        <div className="card manage-user-list">
          <div className="card-body">
            <ul
              className={
                isLoading
                  ? "row list-unstyled mt-4 loading-skeleton"
                  : "row list-unstyled mt-4"
              }
            >
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Invoice No. :-
                  </span>
                  {invoiceDetail?.invoiceNumber || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">
                    Work Order No. :-
                  </span>
                  <span style={{ color: "darkblue", fontWeight: "600", cursor: "pointer" }} onClick={() => navigate(`${RoutesLink.work_order_detail}/${invoiceDetail?.workorder?.id}`)} >{invoiceDetail?.workorder?.workOrderNumber || "--"}</span>
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Date :-</span>
                  {moment(invoiceDetail?.invoiceDate).format("DD-MM-YYYY") ||
                    "--"}
                </p>
              </li>

              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Customer :-</span>
                  {invoiceDetail?.workorder?.site?.customer?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">GST Type :-</span>
                  {invoiceDetail?.workorder?.gstType || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Site :-</span>
                  {invoiceDetail?.workorder?.site?.name || "--"}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Created By :-</span>
                  {invoiceDetail?.user?.name || "--"}{" "}
                  {invoiceDetail?.user?.designation?.name && (
                    <span className="text-muted fs-5">
                      ({invoiceDetail?.user?.designation?.name})
                    </span>
                  )}
                </p>
              </li>
              <li className="col-12 col-md-6 col-lg-3">
                <p>
                  <span className="text-muted fs-5 d-block">Months :-</span>
                  {months?.length > 0 ? months.join(", ") : "--"}
                </p>
              </li>

              <li className="col-12">
                <p>
                  <span className="text-muted fs-5 d-block">Remark :-</span>
                  {invoiceDetail?.remark || "--"}
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="card py-3">
            <Table bordered striped responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Item</th>
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Unit</th>
                  <th>Rate</th>
                  <th>Taxable Amount</th>
                  {invoiceDetail?.workorder?.gstType === "IGST" && (
                    <th>IGST</th>
                  )}
                  {invoiceDetail?.workorder?.gstType === "CGST + SGST" && (
                    <th>CGST</th>
                  )}
                  {invoiceDetail?.workorder?.gstType === "CGST + SGST" && (
                    <th>SGST</th>
                  )}
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoiceDetail?.invoiceitems?.length > 0 ? (
                  [...invoiceDetail?.invoiceitems]
                    ?.sort((a, b) => a?.item?.localeCompare(b?.item))
                    ?.map((item, index) => {
                      let amount = 0,
                        amountWithGST = 0;
                      return (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item?.workorderitem?.item}</td>
                          <td>{item?.workorderitem?.hsnCode}</td>
                          <td>{item?.quantity}</td>
                          <td>{item?.workorderitem?.unit}</td>
                          <td>{formatAmount(item?.workorderitem?.rate)}</td>
                          <td>{formatAmount(item?.taxableAmount)}</td>
                          {invoiceDetail?.workorder?.gstType === "IGST" && (
                            <td>{`${formatAmount(
                              (item?.taxableAmount * item?.workorderitem?.gst) /
                              100
                            )}(${item?.workorderitem?.gst}%)`}</td>
                          )}
                          {invoiceDetail?.workorder?.gstType ===
                            "CGST + SGST" && (
                              <td>{`${formatAmount(
                                (item?.taxableAmount * item?.workorderitem?.gst) /
                                100 /
                                2
                              )}(${item?.workorderitem?.gst / 2}%)`}</td>
                            )}
                          {invoiceDetail?.workorder?.gstType ===
                            "CGST + SGST" && (
                              <td>{`${formatAmount(
                                (item?.taxableAmount * item?.workorderitem?.gst) /
                                100 /
                                2
                              )}(${item?.workorderitem?.gst / 2}%)`}</td>
                            )}
                          <td>{formatAmount(item?.totalAmount)}</td>
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="bg-light p-3 rounded shadow-sm">
              <div className="d-flex gap-4 align-items-center justify-content-end me-4">
                <h4 className="">Total Amount:</h4>
                <p className="fw-medium">
                  {formatAmount(invoiceDetail?.totalAmount) || 0}
                </p>
              </div>
            </div>
            <div className="table-responsive mt-4">
              <table className="table table-bordered text-center">
                <thead className="bg-light">
                  <tr>
                    <th>Description</th>
                    <th>Percentage</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="table-active">
                    <td className="text-start fw-bold">Taxable Amount</td>
                    <td></td>
                    <td className="fw-bold">
                      {formatAmount(invoiceDetail?.taxableAmount) || "--"}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">
                      GST ({invoiceDetail?.workorder?.gstType})
                    </td>
                    <td className="fw-medium">{"--"}</td>
                    <td className="fw-bold text-success">
                      {formatAmount(invoiceDetail?.totalAmount -
                        invoiceDetail?.taxableAmount || 0)}
                    </td>
                  </tr>
                  <tr className="table-active">
                    <td className="text-start fw-bold">Total Amount</td>
                    <td></td>
                    <td className="fw-bold">
                      {formatAmount(invoiceDetail?.totalAmount) || "--"}
                    </td>
                  </tr>

                  <tr>
                    <td className="text-start">TDS</td>
                    <td className="fw-medium">
                      {(invoiceDetail?.tdsPercentage &&
                        invoiceDetail?.tdsPercentage + "%") ||
                        "--"}
                    </td>
                    <td className="fw-bold text-danger">
                      {formatAmount(invoiceDetail?.tdsAmount) || "--"}
                    </td>
                  </tr>
                  <tr>
                    <td className="text-start">Retention</td>
                    <td className="fw-medium">
                      {(invoiceDetail?.rententionPercentage &&
                        invoiceDetail?.rententionPercentage + "%") ||
                        "--"}
                    </td>
                    <td className="fw-bold text-danger">
                      {formatAmount(invoiceDetail?.rententionAmount) || "--"}
                    </td>
                  </tr>
                  <tr className="table-active">
                    <td className="text-start fw-bold">Net Receivable</td>
                    <td></td>
                    <td className="fw-bold">
                      {formatAmount(invoiceDetail?.grossAmount) || "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                <h4 className="d-flex align-items-center mb-4">Bills</h4>
              </div>
              <ul className="row list-unstyled gap-3">
                {invoiceDetail?.documents?.length > 0 ? (
                  invoiceDetail?.documents?.map((doc, index) => {
                    return (
                      <li key={index} className="col-12">
                        <div
                          className="text-muted fs-5 d-flex align-items-center justify-content-between text-decoration-none w-100"
                          onClick={() => handleDocumentClick(doc)}
                          role="button"
                        >
                          <span className="d-flex align-items-center gap-2">
                            <DocumentIcon />
                            {doc?.name || "Document"}
                          </span>
                          <span className="fs-6">
                            {doc?.updatedAt ? moment(doc?.updatedAt).format("DD MMM YYYY | h:mm a") : ""}
                          </span>
                        </div>
                      </li>
                    );
                  })
                ) : (
                  <div>No Document Found</div>
                )}
              </ul>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mb-2">
          {userDetails?.type !== 2 && (
            <button
              className="btn btn-outline-primary fw-bold"
              onClick={() => {
                setEditData("");
                toggleModal();
              }}
            >
              Create Transaction
            </button>
          )}
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="d-flex align-items-center mb-4">Transactions</h4>
                <p
                  className={
                    (+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount) > 1
                      ? "text-danger fw-bold fs-3"
                      : "text-success fw-bold fs-3"
                  }
                >
                  Balance :{" "}
                  {invoiceDetail?.grossAmount || invoiceDetail?.receivedAmount
                    ? (Math.abs(+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount) <= 1
                      ? 0
                      : (+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount).toFixed(2))
                    : 0}
                </p>
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Transaction ID</th>
                      <th>Transaction Date</th>
                      <th>Account Holder Name</th>
                      <th>Account Number</th>
                      <th>Bank Name</th>
                      <th>Reference Name</th>
                      <th>UTR No.</th>
                      <th>Payment Method</th>
                      <th>Type</th>
                      <th>Amount</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceDetail?.transaction?.length > 0 ? (
                      invoiceDetail?.transaction?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-muted">
                            {item?.transactionId || "--"}
                          </td>
                          <td className="text-muted">
                            {moment(item?.transactionDate).format(
                              "YYYY-DD-MM"
                            ) || "--"}
                          </td>
                          <td className="text-muted">
                            {item?.accountHolderName || "--"}
                          </td>
                          <td className="text-muted">
                            {item?.accountNumber || "--"}
                          </td>
                          <td className="text-muted">
                            {item?.bankName || "--"}
                          </td>
                          <td className="text-muted">
                            {item?.referenceName || "--"}
                          </td>
                          <td>{item?.utr || "--"}</td>
                          <td>{item?.paymentMethod || "--"}</td>
                          <td className="text-capitalize">{item?.type}</td>
                          <td
                            className={
                              item?.type === "credit"
                                ? "text-success fw-bold"
                                : item?.type === "debit"
                                  ? "text-danger fw-bold"
                                  : item?.type === "tds"
                                    ? "text-info fw-bold"
                                    : "text-warning fw-bold"
                            }
                          >
                            {item?.amount}
                          </td>
                          <td>
                            <div className="action-btns">
                              <button
                                className="btn btn-link"
                                onClick={() => HandleUpdate(item)}
                                disabled={item?.type === "tds" || item?.type === "due"}
                              >
                                <EditIcon />
                              </button>
                              <button
                                className="btn btn-link"
                                onClick={() => ActionHandler(item)}
                                disabled={item?.type === "tds" || item?.type === "due"}
                              >
                                <DeleteIcon />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center border-0" colSpan="12">
                          <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                            <NoRecordIcon />
                            {"No Transaction found"}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mb-2">
          {userDetails?.type !== 2 && (
            <button
              className="btn btn-outline-primary fw-bold"
              onClick={() => {
                setEditDataForDebitNote("");
                toggleDebitNoteModal();
              }}
            >
              Create Debit Note
            </button>
          )}
        </div>

        <div className="row">
          <div className="card manage-user-list">
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="d-flex align-items-center mb-4">Debit Notes</h4>
                <p
                  className={
                    (+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount) > 1
                      ? "text-danger fw-bold fs-3"
                      : "text-success fw-bold fs-3"
                  }
                >
                  Balance :{" "}
                  {invoiceDetail?.grossAmount || invoiceDetail?.receivedAmount
                    ? (Math.abs(+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount) <= 1
                      ? 0
                      : (+invoiceDetail?.grossAmount - +invoiceDetail?.receivedAmount).toFixed(2))
                    : 0}
                </p>
              </div>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Debit Note no.</th>
                      <th>Transaction Date</th>
                      <th>Amount</th>
                      <th>Remark</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceDetail?.debitNote?.length > 0 ? (
                      invoiceDetail?.debitNote?.map((item, index) => (
                        <tr key={index}>
                          <td className="text-muted">{item?.transactionId}</td>
                          <td className="text-muted">
                            {moment(item?.transactionDate).format(
                              "YYYY-DD-MM"
                            ) || "--"}
                          </td>
                          <td
                            className={
                              item?.type === "credit"
                                ? "text-success fw-bold"
                                : item?.type === "debit"
                                  ? "text-danger fw-bold"
                                  : "text-warning fw-bold"
                            }
                          >
                            {item?.amount}
                          </td>
                          <td className="text-wrap">{item?.remark}</td>
                          <td>
                            <div className="action-btns">
                              <button
                                className="btn btn-link"
                                onClick={() => HandleUpdate(item)}
                              >
                                <EditIcon />
                              </button>
                              <button
                                className="btn btn-link"
                                onClick={() => ActionHandler(item)}
                              >
                                <DeleteIcon />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center border-0" colSpan="12">
                          <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                            <NoRecordIcon />
                            {"No Transaction found"}
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CreateDebitNoteModal
        modal={debitNoteModal}
        toggle={toggleDebitNoteModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
        editData={editDataForDebitNote}
      />
      <CreateTransactionModal
        modal={modal}
        toggle={toggleModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
        editData={editData}
      />
      <ViewDocumentModal
        modal={docModal}
        toggle={toggleDocModal}
        selectedDocument={selectedDocument}
      />
      <ConfirmModal
        modal={deleteModal}
        toggle={toggleDeleteModal}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
      <UpdateBillingDetailsModal
        show={updateBillingModal}
        onClose={toggleUpdateBillingModal}
        invoiceDetail={invoiceDetail}
        GetInvoiceDetail={GetInvoiceDetail}
      />
    </>
  );
}
